// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__GkMqk","small":"Tag_small__1zlnn"};